export default "__VITE_ASSET__D6fJ12dj__"